import React, { useEffect } from 'react';

export default function Ads() {
  useEffect(() => {
    // Load Google Ads script dynamically
    const script = document.createElement('script');
    script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
    script.async = true;
    script.crossOrigin = "anonymous";
    document.body.appendChild(script);

    // Push the ad once the script is loaded
    script.onload = () => {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }

    // Clean up when the component unmounts
    return () => {
      document.body.removeChild(script);
    }
  }, []);

  return (
    <div>
      <ins className="adsbygoogle" style={{ display: 'block' }} data-ad-client="ca-pub-3494715268529530" data-ad-slot="6646961569" data-ad-format="auto" data-full-width-responsive="true"></ins>
    </div>
  );
}
